import { DocumentOutputDTO } from '@types';

export const DocumentMapper = {
  toDTO: (data: Partial<DocumentOutputDTO>): Partial<DocumentOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: DocumentOutputDTO): DocumentOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 